import component from './component.vue';
import FItemArray from '@/plugins/form/FItem/Array';

export default class FDays extends FItemArray {
  __component = component;
}
